import * as React from "react";
import type { SVGProps } from "react";
const SvgCocktails = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={28}
    fill="none"
    {...props}
  >
    <g fill="#050033" clipPath="url(#cocktails_svg__a)">
      <path d="m19.364 25.245-.082.522 6.028-2.17-.395-.347a1.01 1.01 0 0 0-1.013-.193l-1.48.53-1.506-4.155a2.64 2.64 0 0 0 1.19-3.068l-4.28-13.655a.826.826 0 0 0-1.063-.53l-4.551 1.639a.826.826 0 0 0-.485 1.085l5.406 13.26a2.646 2.646 0 0 0 2.87 1.61l1.506 4.155-1.489.513a1.02 1.02 0 0 0-.657.804m.765-6.386a1.84 1.84 0 0 1-2.23-1.094l-2.842-6.968a.528.528 0 0 1 .488-.726h3.315a.53.53 0 0 1 .503.368l1.926 6.181a1.785 1.785 0 0 1-1.16 2.24" />
      <path d="M19.586 13.532a.331.331 0 1 0 0-.663.331.331 0 0 0 0 .663M18.149 13.532a.331.331 0 1 0 0-.663.331.331 0 0 0 0 .663" />
      <path d="M18.755 13.532a.332.332 0 1 0 0-.663.332.332 0 0 0 0 .663M11.464 1.92 6.362.953a.883.883 0 0 0-1.037.738l-2.22 15.162a2.83 2.83 0 0 0 1.768 3.044l-.88 4.647-1.651-.301a1.09 1.09 0 0 0-1.04.373l-.359.428 6.733 1.275-.172-.536a1.09 1.09 0 0 0-.829-.73l-1.651-.3.88-4.648a2.83 2.83 0 0 0 2.758-2.197l3.48-14.924a.88.88 0 0 0-.678-1.064M9.5 10.29 7.77 17.7a1.91 1.91 0 0 1-2.287 1.435 1.97 1.97 0 0 1-1.462-2.222l.998-6.823a.53.53 0 0 1 .524-.44h3.442a.53.53 0 0 1 .515.64" />
      <path d="M5.802 13.58a.356.356 0 1 0 0-.71.356.356 0 0 0 0 .71M7.706 13.58a.356.356 0 1 0 0-.71.356.356 0 0 0 0 .71" />
      <path d="M7.755 13.58a.356.356 0 1 0 0-.71.356.356 0 0 0 0 .71" />
    </g>
    <defs>
      <clipPath id="cocktails_svg__a">
        <path fill="#fff" d="M0 .938h26.25v26.25H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCocktails;
